import { ProductCardViewData } from '@services/MarppleShop/features/ProductList/type';
import { html, View } from 'rune-ts';
import {
  CardProductError,
  CardProductView,
} from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';
import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';
import { pushLoginStack } from '@modules/Creator/Login/F/fs';
import { updateLikeMarppleShop } from '@modules/MShop/App/Product/Item/F/Function/updateLikeMarppleShop';
import { differenceInMilliseconds } from 'date-fns';
import { delay, noop } from '@fxts/core';

/**
 * @see https://github.com/marpple/marpple-web/blob/c69213b737c26d28b5417bc5767aaf4a2b953760/services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts#L274-L288
 */
const HEURISTIC_DELAY_MS = 1000;

type TTypeACardProductViewProps =
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Horizontal';
      theme: 'Dark';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Small';
      layout: 'Horizontal';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'A';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeBCardProductViewProps =
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'B';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeCCardProductViewProps =
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'C';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeDCardProductViewProps =
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'D';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    };

type TTypeECardProductViewProps =
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'E';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeFCardProductViewProps =
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'F';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

type TTypeGCardProductViewProps =
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xsmall';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Small';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Medium';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Large';
      layout: 'Vertical';
      theme: 'Light';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    }
  | {
      type: 'G';
      size: 'Xlarge';
      layout: 'Vertical';
      theme: 'Dark';
    };

export type TCardProductViewProps =
  | TTypeACardProductViewProps
  | TTypeBCardProductViewProps
  | TTypeCCardProductViewProps
  | TTypeDCardProductViewProps
  | TTypeECardProductViewProps
  | TTypeFCardProductViewProps
  | TTypeGCardProductViewProps;

type TProps = {
  card_product_view_props: TCardProductViewProps;
  product_card_view_data: ProductCardViewData;
  options: {
    resize_width: number;
    is_lazy?: boolean;
  };
};

export class CardProductControllerView extends View<TProps> {
  private card_product_view: CardProductView;

  constructor(props: TProps) {
    super(props);

    const { product_card_view_data, card_product_view_props } = props;

    const product_image = {
      thumbnail_info: product_card_view_data.thumbnail_info,
      is_liked: product_card_view_data.is_liked,
      is_lazy: props.options?.is_lazy ?? false,
      resize_width: props.options.resize_width,
      domain_name: product_card_view_data.domain_name,
      id: product_card_view_data.id,
      name: product_card_view_data.name,
      store_name: product_card_view_data.store_name,
    };

    const shop = {
      domain_name: product_card_view_data.domain_name,
      store_name: product_card_view_data.store_name,
      profile_image_url: product_card_view_data.profile_image_url,
      // @TODO sws: UI 확정 후 ?? 삭제
      watcher_count: product_card_view_data.watcher_count ?? 0,
    };

    const product_title = {
      name: product_card_view_data.name,
      domain_name: product_card_view_data.domain_name,
      id: product_card_view_data.id,
    };

    const price = {
      price: product_card_view_data.price,
      price_en: product_card_view_data.price_en,
      price_jp: product_card_view_data.price_jp,
    };

    const review = {
      review_score: product_card_view_data.review_score,
      review_count: product_card_view_data.review_count,
    };

    const count_view = {
      // @TODO sws: UI 확정 후 ?? 삭제
      watcher_count: product_card_view_data.watcher_count ?? 0,
    };

    const realtime = {
      ordered_at: product_card_view_data.ordered_at,
    };

    const badge_main = {
      ranking: product_card_view_data.ranking,
      quantity: product_card_view_data.quantity,
      order_count: product_card_view_data.order_count,
      sell_end_at: product_card_view_data.sell_end_at,
      ordered_at: product_card_view_data.ordered_at,
    };

    const badge_subs = {
      sell_end_at: product_card_view_data.sell_end_at,
      quantity: product_card_view_data.quantity,
      order_count: product_card_view_data.order_count,
    };

    if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Horizontal'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Horizontal'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'A' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        count_view,
        badge_main: {
          ranking: badge_main.ranking,
          ordered_at: badge_main.ordered_at!,
        },
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        realtime: {
          ordered_at: realtime.ordered_at!,
        },
        count_view,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        realtime: {
          ordered_at: realtime.ordered_at!,
        },
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'B' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        badge_main: {
          ranking: badge_main.ranking,
          ordered_at: badge_main.ordered_at!,
        },
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'C' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'C' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'D' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        count_view,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'D' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        count_view,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        badge_main,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        badge_main,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        badge_main,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'E' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        badge_main,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        review,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        review,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        review,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'F' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        shop,
        product_title,
        price,
        review,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Xsmall' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        review,
        count_view,
        // @TODO sws: 임시
        // badge_main,
        // badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Small' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        review,
        count_view,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Medium' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        review,
        count_view,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Large' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        review,
        count_view,
        // @TODO sws: 임시
        // badge_main,
        // badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else if (
      card_product_view_props.type === 'G' &&
      card_product_view_props.size === 'Xlarge' &&
      card_product_view_props.layout === 'Vertical'
    ) {
      this.card_product_view = new CardProductView({
        ...card_product_view_props,
        state: CardProductView.getState(product_card_view_data),
        product_image,
        product_title,
        price,
        review,
        count_view,
        badge_main,
        badge_subs,
        onProductImageLikeClick: () => this.handleProductImageLikeClick(),
      });
    } else {
      throw new CardProductError();
    }
  }

  /**
   * @see https://github.com/marpple/marpple-web/blob/c69213b737c26d28b5417bc5767aaf4a2b953760/services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts#L301-L329
   */
  private handleProductImageLikeClick = async () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!this.data.product_card_view_data.user_id || window.box.sel('is_user->type') == 'TEMP') {
      const confirmed = (await Confirm.open({
        title: ET('mps2::login::need_login::title'),
        message: preventEscape(ET('mps2::login::need_login::message')),
        confirmText: ET('mps2::login::login'),
        cancelText: ET('mps2::signup::close'),
      })) as boolean;

      if (confirmed) {
        if (MShopUtilF.isApp()) {
          pushLoginStack();
        } else {
          location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`;
        }
      }
    } else {
      try {
        const next_is_liked = !this.data.product_card_view_data.is_liked;
        updateLikeMarppleShop(!next_is_liked, this.data.product_card_view_data.stores_product_id);
        this.data.product_card_view_data.is_liked = next_is_liked;
        this.card_product_view.setProductImageIsLiked(next_is_liked);
      } catch {
        noop();
      }
    }
  };

  protected override async onMount() {
    const sell_end_at = this.data.product_card_view_data.sell_end_at;
    if (sell_end_at) {
      const time_until_sell_end_ms = differenceInMilliseconds(sell_end_at, new Date());
      await delay(time_until_sell_end_ms + HEURISTIC_DELAY_MS);
      // @TODO sws: 배지 갱신
    }
  }

  protected override template() {
    return html`<div>${this.card_product_view}</div>`;
  }
}
